export const extractCode = (
	text: string
): { code: string; language: string } => {
	const openingFence = /(?:^|\r?\n)```([^\r\n]*)\r?\n/.exec(
		text
	);
	if (openingFence?.index !== undefined) {
		const codeStart =
			openingFence.index + openingFence[0].length;
		// Use the final fence so Markdown fences embedded in generated
		// Python strings do not truncate the full blob content.
		const codeEnd = text.lastIndexOf("\n```");

		if (codeEnd >= codeStart) {
			const declaredLanguage = openingFence[1]
				.trim()
				.toLowerCase();
			const language = ["abf", "python"].includes(
				declaredLanguage
			)
				? declaredLanguage
				: "plaintext";
			return {
				code: text.slice(codeStart, codeEnd).trimEnd(),
				language,
			};
		}
	}

	return { code: text, language: "plaintext" };
};
